
import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import check from "../../check.png";
import edit from "../../edit.png";
import zoom from "../../zoom.png";
import time from "../../time.png";


import SupportNew from "./SupportNew";
import SupportView from "./SupportView";

import PlTitle from "../../elements/PlTitle";
import MenuTable from "../../helpers/MenuTable";



function Support(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);



    const [telPass, setTelPass] = useState(null);

    const [view, setView] = useState( {  v:"normal", id:""  });



    const changeView = (e) => {

        var v = e.target.getAttribute("v");
        var id = e.target.getAttribute("id");

        setView(  {...view, ["v"]:v, ["id"]:id } );
    
  }




  const getTelPass = () => {
       
 
    props.mainView.setProgress(-2);

    var req = {
    
    };

    fetch( Config.url + '/rest_v1,telPass', {
        method: 'POST', 
        body: JSON.stringify(req), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTelPass(res);              
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}





    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,support', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


   
  

    const modify = (e) => {

        setView(  {...view, ["v"]:"", ["id"]:-1 } );
        getData();
    }


    if(telPass == null )
    {
        setTelPass([]);
        getTelPass();
    }


    


    if(tab == null)
    {
        setTab([]);
        getData(); 
        return (
            <div></div>
        );        
    }


    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }



    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        getData();
    }
 


    if(view.v == "edit")
    {      
            var row = [];

            for(var k=0; k<tab.result.length; k++)
            {
                if(tab.result[k].id == view.id)
                {
                    row = tab.result[k];
                }
            }

            return <SupportView  userData={props.userData} mainView={props.mainView}  back={modify} row={row} />
    }


    var pSeleted = "";
    var pSeletedId = -1;
    var pakiet = "";

    for(var pi =0; pi<props.userData.pl.length; pi++ )
    {
        if(props.userData.pl[pi]['id']  == props.userData.p_przedszkole_id)
        {

            var xnazwa = props.userData.pl[pi]['nazwa'];

            if(xnazwa.length > 15) xnazwa = xnazwa.substring(0,15) + "...";

            pSeleted =  xnazwa+ ", " + props.userData.pl[pi]['ulica']  + "( ID: "+props.userData.pl[pi]['id'] +")";
            pSeletedId = props.userData.pl[pi]['id']
            pakiet = props.userData.pl[pi]['pakiet']  ;
        }
    }



    return (
        <div className="view_content">
         


            <div>

                <h1>800 808 868 (infolinia bezpłatna) </h1>
                <h3>ID Klienta / Placówki: {pSeletedId}</h3>

                {
                    telPass != null && telPass.pass != undefined &&
                    <Fragment>
                        <div>
                            Telefoniczne hasło klienta:  <b>{telPass.pass}</b> (wykonaj połączenie z numeru zarejestrowanego w systemie) 
                        </div>
                        <br/>
                        
                    </Fragment>

                }

            </div>

            <div className="tip">
                Przed kontaktem telefonicznym wyślij zgłoszenie za pomocą poniższej opcji. Opisz problem podając szczegóły (np. imię nazwisko dziecka, numer rozliczenia, umowy, itd.)
            </div>

          

            <div className="bg_center">   

            <div className="table_widget">
                <SupportNew userData={props.userData} mainView={props.mainView}  back={modify} />
            </div>

                
                <table className="table">
                            <thead>
                                <tr className="header">
                                    <td className="td_left">LP</td>                           
                                    <td>Numer</td>  
                                    <td>Data zgłoszenia</td>  
                                    <td>Zgłaszający</td>  
                                    <td>Temat</td>  
                                    <td>Treść</td>  
                                    <td>Załączniki</td> 
                                    <td>Poświęcony czas (min.)</td>
                                    <td>Opł. dodatkowa za realizacje zadania</td>
                                    <td className="td_right">Stan zgłoszenia</td>       
                                    <td className="td_option"></td>                              
                                </tr>
                            </thead>
                            <tbody>
                            

                                {
                                    tab.result.map(  (item, ix) => {

                                    var ac = '-';
                                    if(item.stan == '2') ac = <img src={check} title="zakończone" />
                                    if(item.stan == '3') ac = <img src={time} title="w trakcie realizacji" />
                                    if(item.stan == '1') ac = <img src={time} title="zgłoszenie przyjęte" />

                                    var czas = '-';
                                    if(item.poswiecony_czas > 0) czas = item.poswiecony_czas;


                                    var rowStyle = " row ";
                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                    return (
                                            <tr className={rowStyle}>
                                                <td className="gocenter">{ (ix + 1) }</td>                                                                     
                                                <td className="gocenter">{ item.numer }</td> 
                                                <td className="gocenter">{ item.data_zgloszenia }</td> 
                                                <td className="">{ item.imie + " " + item.nazwisko }</td> 
                                                <td className="">{ item.temat }</td> 
                                                <td className="">{ item.tresc }</td> 
                                                <td className="gocenter">{ item.pliki.length }</td>
                                                <td className="gocenter">{czas}</td>
                                                <td className="goright">{item.kwota_do_faktury}</td>
                                                <td className="gocenter">{ ac}</td> 
                                                <MenuTable>
                                                    <ul>
                                                        <li  onClick={changeView} v="edit" id={item.id} >pokaż</li>
                                                    </ul>
                                                </MenuTable>
                                        
                                            </tr>
                                            )
                                    } )
                                }

                            </tbody>
                </table>

            </div>

        </div>
    )
}


export default Support;